import WebSocketManager from './WebSocketManager';
import config from '../../config/config';


let _socketManager = new WebSocketManager();
_socketManager.config = {
    stomp: {
        url_ws: config.RABBIT_URL,
        login: config.RABBIT_LOGIN,
        password: config.RABBIT_PASSWORD,
        virtual_host: config.RABBIT_VIRTUAL_HOST,
    },
};


function disconnect() {
    if(_socketManager) {
        _socketManager.disconnect();
    }
}

function sendToExchange(exchange, routingKey, data) {
    if(!_socketManager.client) {
        return;
    }

    _socketManager.client.send(
        `/exchange/${exchange}/${routingKey}`,
        null,
        JSON.stringify(data)
    );
}

async function connect() {
    _socketManager.disconnect();

    _socketManager.onError = (error) => {
        //reject(error);
        console.log('error', error);
    };

    await _socketManager.init();
}

function setListener(exchange, routingKey, f) {
    _socketManager.onConnect = () => {
        _socketManager.client.subscribe(
            `/exchange/${exchange}/${routingKey}`,
            (d) => {
                let data = JSON.parse(d.body);

                if(typeof f == 'function') {
                    f(data);
                }
            }
        );
    };
}

function getSocketManager() {
    return _socketManager;
}


export default {
    connect,
    disconnect,
    setListener,
    sendToExchange,
    getSocketManager,
}
